import type { EchoMark as EchoMarkIcon } from "@/config/constants";
import type { IconProps } from "@iconify/react";

import { Icon } from "@iconify/react";

import { EchoMark } from "@/components/common/echo-mark";
import { ECHO_MARK } from "@/config/constants";

/** An Iconify name or Echo's mark: what data that names icons should hold. */
export type AppIconName = IconProps["icon"] | EchoMarkIcon;

interface AppIconProps extends Omit<IconProps, "icon"> {
  icon: AppIconName;
  /** Echo's mark only: the `thinking` face. Keep it for surfaces where Echo
   *  is working right now; a mark that only attributes work stays still. */
  isLive?: boolean;
}

const isEchoMark = (icon: AppIconName): icon is EchoMarkIcon =>
  typeof icon === "object" && "mark" in icon && icon.mark === ECHO_MARK.mark;

/** `Icon`, except Echo's mark draws the pebble, so data that names icons (nav
 *  items, workflow nodes, feed rows) can carry it too. */
export const AppIcon = ({ icon, isLive = false, ...props }: AppIconProps) =>
  isEchoMark(icon) ? (
    <EchoMark
      className={props.className}
      expression={isLive ? "thinking" : "idle"}
      size={props.width ?? props.height ?? props.fontSize ?? "1em"}
    />
  ) : (
    <Icon icon={icon} {...props} />
  );
